var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-rate',{attrs:{"max":_vm.max,"disabled":_vm.disabledValue,"allow-half":_vm.allowHalf,"show-text":_vm.showText,"texts":_vm.texts,"show-score":_vm.showScore,"text-color":_vm.textColor},on:{"change":_vm.change},model:{value:(_vm.fvalue),callback:function ($$v) {_vm.fvalue=$$v},expression:"fvalue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }